import React from "react";
import { Navigate } from "react-router-dom";

// Authentication related pages
import Login from "../pages/Authentication/Login";
import Logout from "../pages/Authentication/Logout";
import ForgetPwd from "../pages/Authentication/ForgetPassword";
import AuthLockScreen from "../pages/Authentication/AuthLockScreen";
import MobileDownloadPage from "../pages/MobileDownload/MobileDownloadPage";
import { DASHBOARD_PAGE, MODULE_SELECTOR_PAGE, MOBILE_DOWNLOAD_PAGE, PRAMETRAGE_PAGE, VVINAL_PAGE, DATABASE_VEHICULE_MANAGER_PAGE, DATABASE_VEHICULE_PAGE, DATABASE_CLIENT_PAGE, DATABASE_VEHICULE_FORM, DATABASE_VEHICULE_EDIT, DATABASE_CLIENT_FORM, DATABASE_CLIENT_EDIT, ENCHERES_PAGE, VHU_LOTS_PAGE, VHU_BID_OFFERS_PAGE, FERRAILLEURS_ENCHERES_VISIBLES_PAGE, FERRAILLEURS_MES_ACHATS_PAGE, FERRAILLEURS_TERMS_PAGE, RESEAU_PAGE  } from "./routeConstants";
import ParametragePage from "../modules/parametrage/index";
import VVinalPage from "../modules/valeurVinal/vVinalPage";
import VehiculePage from "../modules/database/VehiculePage";
import VehiculeManagerPage from "../modules/database/VehiculeManagerPage";
import ClientPage from "../modules/database/ClientPage";
import VehiculeForm from "../modules/database/VehiculeForm";
import ClientForm from "../modules/database/ClientForm";
import ModuleSelectorPage from "../modules/moduleSelector/ModuleSelectorPage";
import VhuLotsAdminPage from "../modules/vhu/VhuLotsAdminPage";
import VhuBidOffersPage from "../modules/vhu/VhuBidOffersPage";
import FerrailleurEncheresVisiblesPage from "../modules/ferrailleurs/FerrailleurEncheresVisiblesPage";
import MesAchatsPage from "../modules/ferrailleurs/MesAchatsPage";
import TermesConditionsPage from "../modules/ferrailleurs/TermesConditionsPage";
import ReseauPage from "../modules/reseau/ReseauPage";


const authProtectedRoutes = [
    { path: MODULE_SELECTOR_PAGE, component: <ModuleSelectorPage />, withoutLayout: true },
    { path: DASHBOARD_PAGE, component: <VehiculePage /> },
    { path: DATABASE_VEHICULE_MANAGER_PAGE, component: <VehiculeManagerPage /> },

	{ path: DATABASE_VEHICULE_PAGE, component: < VehiculePage/> },
	{ path: DATABASE_VEHICULE_FORM, component: <Navigate to={DATABASE_VEHICULE_MANAGER_PAGE} /> },
	{ path: DATABASE_VEHICULE_EDIT, component: <VehiculeForm /> },

	{ path: DATABASE_CLIENT_PAGE, component: < ClientPage/> },
	{ path: DATABASE_CLIENT_FORM, component: <ClientForm /> },
	{ path: DATABASE_CLIENT_EDIT, component: <ClientForm /> },	

    { path: VVINAL_PAGE, component: <VVinalPage /> },
    { path: PRAMETRAGE_PAGE, component: <ParametragePage /> },
    { path: ENCHERES_PAGE, component: <Navigate to={VHU_LOTS_PAGE} /> },
    { path: VHU_LOTS_PAGE, component: <VhuLotsAdminPage /> },
    { path: VHU_BID_OFFERS_PAGE, component: <VhuBidOffersPage /> },
    { path: FERRAILLEURS_ENCHERES_VISIBLES_PAGE, component: <FerrailleurEncheresVisiblesPage /> },
    { path: FERRAILLEURS_MES_ACHATS_PAGE, component: <MesAchatsPage /> },
    { path: FERRAILLEURS_TERMS_PAGE, component: <TermesConditionsPage /> },
    { path: RESEAU_PAGE, component: <ReseauPage /> },

	// this route should be at the end of all other routes
	{ path: "/", exact: true, component: <Navigate to={MODULE_SELECTOR_PAGE} />, withoutLayout: true },
];

const publicRoutes = [
	{ path: MOBILE_DOWNLOAD_PAGE, component: <MobileDownloadPage /> },
	{ path: "/mobile", component: <MobileDownloadPage /> },
	{ path: "/logout", component: <Logout /> },
	{ path: "/login", component: <Login /> },
	{ path: "/forgot-password", component: <ForgetPwd /> },
	{ path: "/lock-screen", component: <AuthLockScreen /> },
];

export { authProtectedRoutes, publicRoutes };
